module.exports = {
          srcSet: __webpack_public_path__ + "dbba0f368dfb302ab797aa56bb4ffcc7-291.png"+" 291w",
          images:[ {path: __webpack_public_path__ + "dbba0f368dfb302ab797aa56bb4ffcc7-291.png",width: 291,height: 326}],
          src: __webpack_public_path__ + "dbba0f368dfb302ab797aa56bb4ffcc7-291.png",
          toString:function(){return __webpack_public_path__ + "dbba0f368dfb302ab797aa56bb4ffcc7-291.png"},
          
          width: 291,
          height: 326
        }